/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SimpleModal from '../SimpleModal/SimpleModal';
import Button from '../Basic/Button';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import FlatSearchGrey from '../Basic/FlatSearchGrey';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiDialogActions-root button:first-child': {
      minWidth: '64px',
    },

    '& .MuiDialogContent-root': {
      overflow: 'hidden',
    },

    '& .MuiDialogTitle-root': {
      '& h2.MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 500,
      },
    },

    '& .SearchPanel': {
      marginBottom: 14,
    },

    '& section': {
      paddingBottom: 16,
      maxHeight: 400,
      minWidth: 220,
      overflow: 'auto',
      overflowX: 'hidden',

      '& ul': {
        margin: 0,
        padding: 0,
      },

      '& li': {
        paddingLeft: 18,
      },
    },
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,

    '& .MuiSvgIcon-root': {
      fontSize: '1.3rem',
    },
  },
}));

const ViewFilterModal = ({
  title,
  open = false,
  onClose,
  onConfirm,
  onClear,
  disabled = false,
  children,
  className = '',
  serachTerm,
  onSearch,
  onSearchInput,
  onSearchClear,
}) => {
  const classes = useStyles();

  return (
    <SimpleModal
      open={open}
      onClose={onClose}
      className={`ViewFilterModal ${classes.root} ${className}`}
      onClick={(evt) => evt.stopPropagation()}
      title={
        <div>
          {title}{' '}
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      }
      controlChildren={
        <div>
          <Button
            onClick={onConfirm}
            disabled={disabled}
            color="primary"
            variant="contained"
          >
            Apply filters
          </Button>
          <Button color="primary" onClick={onClear}>
            Clear filters
          </Button>
        </div>
      }
    >
      <div className="SearchPanel">
        <FlatSearchGrey
          placeholder="Search"
          value={serachTerm}
          onSearch={onSearch}
          onChange={onSearchInput}
          onClear={onSearchClear}
          onEsacpe={onSearchClear}
          name="view-search"
        />
      </div>
      <section>{children}</section>
    </SimpleModal>
  );
};

export default ViewFilterModal;
